import { type TimeRange } from '../../types';

const isTimeSet = (hour?: number, minute?: number) =>
	(hour || hour === 0) && (minute || minute === 0);

const isTimeValid = (hour: number, minute: number) =>
	hour >= 0 && hour <= 24 && minute >= 0 && minute <= 60;

export const isValidRange = (range: TimeRange) => {
	return (
		isTimeSet(range.startHour, range.startMinute) &&
		isTimeValid(range.startHour, range.startMinute) &&
		isTimeSet(range.endHour, range.endMinute) &&
		isTimeValid(range.endHour, range.endMinute)
	);
};

const getFormattedRange = (value: TimeRange): [string, string] => {
	return [
		`${value.startHour || '00'}:${value.startMinute || '00'}`,
		`${value.endHour || '00'}:${value.endMinute || '00'}`,
	];
};

export { getFormattedRange };
